import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import myGlobals = require('../config');

@Injectable()
export class EmailService {

    private emailUrl = myGlobals.default.BASE_URL+'/email/';  // URL to web api

    constructor(private http: Http) { }


    // Agregar nuevo usuario
    public enviar(email: any):Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8'});
        headers.append('dataType', 'json');
        var usuarioStr=JSON.stringify(email);
        return this.http
            .post(this.emailUrl, usuarioStr, {headers: headers})
            .map((response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/landingPage/email.service.ts